import { render, staticRenderFns } from "./PublishStatusFilter.vue?vue&type=template&id=80896d50&"
import script from "./PublishStatusFilter.vue?vue&type=script&lang=js&"
export * from "./PublishStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports